import { Box, Heading, Text, OrderedList, ListItem, Link } from "@chakra-ui/react";

const GDriveSetupGuide = () => {
  return (
    <Box maxW="800px" mx="auto" p={6} borderWidth="1px" borderRadius="lg" boxShadow="lg">
      <Heading as="h2" size="xl" mb={4} textAlign="center">
        Google Drive API Service Account Setup
      </Heading>

      <Text fontSize="lg" mb={4}>
        Follow these steps to create a Google Service Account for programmatic access to Google Drive.
      </Text>

      <OrderedList spacing={4}>
        <ListItem>
          <Text fontWeight="bold">Create a Service Account</Text>
          <OrderedList pl={4}>
            <ListItem>
              Go to <Link color="blue.500" href="https://console.cloud.google.com/" isExternal>Google Cloud Console</Link>.
            </ListItem>
            <ListItem>Select or create a new project.</ListItem>
            <ListItem>Navigate to "IAM & Admin" → "Service Accounts".</ListItem>
            <ListItem>Click "Create Service Account" and fill in details.</ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <Text fontWeight="bold">Grant Access to Google Drive API</Text>
          <OrderedList pl={4}>
            <ListItem>Assign the role <b>Editor</b> or <b>Cloud Storage Viewer</b>.</ListItem>
            <ListItem>Click Continue & Done.</ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <Text fontWeight="bold">Generate & Download the JSON Key</Text>
          <OrderedList pl={4}>
            <ListItem>Go to the "Keys" tab in your Service Account.</ListItem>
            <ListItem>Click "Add Key" → "Create New Key" → Select JSON.</ListItem>
            <ListItem>Download the key file securely.</ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <Text fontWeight="bold">Enable Google Drive API</Text>
          <OrderedList pl={4}>
            <ListItem>Go to "APIs & Services" → "Library".</ListItem>
            <ListItem>Search for "Google Drive API" and enable it.</ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <Text fontWeight="bold">Share Google Drive Folder</Text>
          <OrderedList pl={4}>
            <ListItem>Go to <Link color="blue.500" href="https://drive.google.com/" isExternal>Google Drive</Link>.</ListItem>
            <ListItem>Right-click the folder → "Share".</ListItem>
            <ListItem>Enter the service account email.</ListItem>
            <ListItem>Set permissions to "Viewer" or "Editor".</ListItem>
          </OrderedList>
        </ListItem>
      </OrderedList>

      <Box mt={6} textAlign="center">
        <Text fontSize="md">
          Need more details? Visit Google’s official guide:
          <Link
            href="https://cloud.google.com/iam/docs/creating-managing-service-accounts"
            color="blue.500"
            isExternal
            ml={1}
          >
            Google Docs
          </Link>
        </Text>
      </Box>
    </Box>
  );
};

export default GDriveSetupGuide;
